import React from 'react';
import CustomizedTooltips from '../components/tooltip.component';
import { allergen } from '../tools/utils';
import { ALLERGEN } from '../constants/base-data.constant';
import i18n from '../i18n';

//  菜品其他信息组件
export class MenuDetailInfo extends React.Component<Props, State>{

    constructor(props: Props) {
        super(props);
        this.state = {
            // 气泡标签显示
            setToolTip: false,
        }
    };


    public handleTooltipClose = () => {
        this.setState({
            setToolTip: false
        })
    }
    public handleTooltipOpen = () => {
        this.setState({
            setToolTip: !this.state.setToolTip
        })
    }
    /**
     * 获取过敏原或者其他菜品信息的名称
     * @param name 
     */
    private getDetailInfoName(name: string) {
        let index = ALLERGEN.findIndex(target => target.key === name);
        if (index !== -1) {
            return i18n.t(ALLERGEN[index].text);
        } else {
            return name;
        }
    }
    // *********************
    // View
    // *********************
    public render() {
        const { imgPath } = this.props;
        return (
            <div>
                <div>
                    <CustomizedTooltips
                        arrow
                        onClose={this.handleTooltipClose}
                        open={this.state.setToolTip}
                        disableFocusListener
                        title={this.getDetailInfoName(imgPath)}
                    >
                        <img onClick={this.handleTooltipOpen} src={allergen(imgPath)} alt={imgPath} />
                    </CustomizedTooltips>
                </div>
            </div>
        )
    }
}

// *********************
// Types
// *********************

type Props = {
    imgPath: string,
}
type State = {
    setToolTip: boolean
}